import { render } from "./WaterTab.vue?vue&type=template&id=cf1a607c&ts=true"
import script from "./WaterTab.vue?vue&type=script&lang=ts"
export * from "./WaterTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__